import { Controller, useFormContext } from "react-hook-form"
import DropdownInput from "../DropdownInput"
import styled from "styled-components"
import { TextDiv } from "../../common/Text"

const PositionDropdown = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const dropdownOptions = {
    handleName: "직책",
    options: [
      "중학생",
      "고등학생",
      "대학생/대학원생",
      "교사",
      "학부모",
      "일반",
    ],
  }

  return (
    <RelativeDiv>
      <Controller
        control={control}
        name="position"
        render={({ field: { onChange } }) => (
          <DropdownInput
            handleName={dropdownOptions.handleName}
            selectOptions={dropdownOptions.options}
            onChange={onChange}
            $isError={errors.position ? true : false}
          />
        )}
      />
      {errors.position && (
        <TextDiv
          fontSize={11}
          color="var(--custom-light-red)"
          $align="start"
          style={{
            marginTop: 10,
            paddingLeft: 25,
            position: "absolute",
            top: 45,
          }}
        >
          * {errors.position.message?.toString()}
        </TextDiv>
      )}
    </RelativeDiv>
  )
}

export default PositionDropdown

const RelativeDiv = styled.div`
  position: relative;
`
